export default function Line(props: {
  // type?: 'horizontal' | 'vertical';
  className?: string;
  width?: number | string;
  height?: number | string;
  color?: string;
}) {
  const { className, width = 1, height = 1, color = '#404347' } = props;
  return (
    <div
      className={className}
      style={{
        width,
        height,
        background: color,
      }}
    ></div>
  );
}
